import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './pages/home/home.component';
import {InspectionComponent } from './pages/inspection/inspection.component';
import {PlantMasterComponent } from './pages/plantMaster/plantMaster.component';
import {JobPlantComponent } from './pages/jobPlant/jobPlant.component';

const appRoutes: Routes = [
    // {path: '', redirectTo: '/', pathMatch: 'full'},  //TODO: Setup default startup page
    {path: '', redirectTo: '/inspection', pathMatch: 'full'},
    {path: 'home', component: HomeComponent},
    {path: 'inspection', component: InspectionComponent},
    {path: 'plantMaster', component: PlantMasterComponent},
    {path: 'jobPlant', component: JobPlantComponent}
  ];

  @NgModule({
    imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
    exports: [RouterModule]
  })
  export class AppRoutingModule {
  
  }